module.exports = __webpack_public_path__ + "img/invoice-de-male-hb.91fb5545.png";